import { css } from 'linaria';

export const total = css`
  white-space: nowrap;
`;
